var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('b-table',{attrs:{"data":_vm.conflictsData,"columns":_vm.conflictColumns,"default-sort":"shoppingCenterGroupName","default-sort-direction":"asc","row-class":(row, index) => 'is-danger'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }